import { useTranslation } from 'react-i18next';
import styles from './InactiveUsersList.module.css';
import { UserDTO } from '@/openapi';
import Pagination from '@/components/UI/Paging';

interface InactiveUsersListProps {
	userList?: UserDTO[];
	paginationContext?: string;
	dataType?: 'user' | 'signaller' | 'signaller-a';
}

const InactiveUsersList = (props: InactiveUsersListProps) => {
	const { t } = useTranslation();
	const { userList } = props;

	return (
		<>
			<div className={styles.inactive_user_content}>
				<h2 className={styles.listTitle}>
					{props.dataType === 'user'
						? t('adminPage.statsSection.notActiveUsers')
						: props.dataType === 'signaller'
						? t('adminPage.statsSection.inactiveSignallers')
						: t('adminPage.statsSection.activeSignallers')}
				</h2>

				<div className={styles.listContainer}>
					{userList && userList.length > 0 ? (
						userList.map((user) => (
							<div key={user.id || user.login} className={styles.userItem}>
								<div className={styles.userInfo}>
									<span className={styles.userLogin}>@{user.login || 'N/A'}</span>
								</div>
								<div className={styles.userContact}>
									<span className={styles.userEmail}>{user.email || t('common.noEmail', 'Email non fornita')}</span>
								</div>
							</div>
						))
					) : (
						// Empty list
						<p className={styles.noUsersMessage}>
							{props.dataType === 'user'
								? t('adminPage.statsSection.inactiveUsersEmpty')
								: props.dataType === 'signaller'
								? t('adminPage.statsSection.inactiveSignallersEmpty')
								: t('adminPage.statsSection.activeSignallersEmpty')}
						</p>
					)}
				</div>

				{/* Componente di paginazione */}
				<Pagination contextId={props.paginationContext} />
			</div>
		</>
	);
};

export default InactiveUsersList;
